(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["triton-footage-switcher"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('triton-footage-switcher')) {
    customElements.define('triton-footage-switcher', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const buttons = [...this.querySelectorAll('[data-footage-index]')];
        const panels = [...this.querySelectorAll('[data-footage-panel]')];
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          panels.forEach((panel, panelIndex) => {
            const active = panelIndex === index;
            panel.hidden = !active;
            buttons[panelIndex].setAttribute('aria-pressed', String(active));
            const video = panel.querySelector('video');
            if (!video) return;
            if (active) {
              video.muted = true;
              video.play().catch(() => {});
            } else video.pause();
          });
        }));
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
